/**
 * Reads a user-facing message from typical REST/JSON error bodies.
 */
export function extractApiErrorMessage(data, fallback = "") {
  if (!data || typeof data !== "object") return fallback || "";
  const fromMessage =
    typeof data.message === "string" && data.message.trim()
      ? data.message.trim()
      : "";
  if (fromMessage) return fromMessage;
  if (typeof data.error === "string" && data.error.trim()) return data.error.trim();
  if (
    data.error &&
    typeof data.error === "object" &&
    typeof data.error.message === "string" &&
    data.error.message.trim()
  ) {
    return data.error.message.trim();
  }
  const first = Array.isArray(data.errors) ? data.errors[0] : null;
  if (first && typeof first.message === "string" && first.message.trim()) {
    return first.message.trim();
  }
  return fallback || "";
}